module.exports = __webpack_public_path__ + "img/Rust-Inspect-Portrait.232d2e6b.png";